export default __webpack_public_path__ + "static/media/logo.b8e18fe6.png";